import React from 'react';
import styled from 'styled-components';

import TileGrid from '../components/tileGrid';
import TileSlider from '../components/tileSlider';
import { stylesFor } from '../styles/utilities';

const ResponsiveTileSlider = styled(TileSlider)`
  && {
    ${stylesFor.smallUp`
      display: none;
    `};
  }
`;

const ResponsiveTileGrid = styled(TileGrid)`
  && {
    ${stylesFor.underSmall`
      display: none;
    `};

    ${stylesFor.mediumUp`
      margin-top: 40px;
    `};
  }
`;

export default ({ tiles, gridRowsMedium, gridRowsLarge }) => {
  return (
    <div>
      <ResponsiveTileSlider tiles={tiles} />
      <ResponsiveTileGrid
        tiles={tiles}
        mediumRows={gridRowsMedium}
        largeRows={gridRowsLarge}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/responsiveTileView.js